import React from 'react';
import ServicesPage from '../../components/Services/ServicesPage';
import ServiceImg1 from '../../assets/images/services/8.png';
import ServiceImg2 from '../../assets/images/services/5.png';
import ServiceImg4 from '../../assets/images/services/7.png';
import ServiceImg5 from '../../assets/images/services/2.png';
import ServiceImg6 from '../../assets/images/services/3.png';
import ContactThree from './ContactThree';
import { useState } from 'react';
import TestimonialOne from '../../components/Slider/TestimonialOne';
import teamDetailsImg from '../../assets/images/team/team1.png';
import teamDtetailsShape from '../../assets/images/shapes/team-details-name-box-shape.png';

const ServicesMain = () => {
    const [serviceDetails] = useState({
            title: "We're Hiring",
            text1: "Join our dynamic team and contribute to exciting projects in a collaborative environment. We value innovation, dedication, and passion. If you’re ready to make an impact and grow with us, apply now and become a part of our success story."
        })
    const servicesData = [
        {
          imgSrc: ServiceImg1,
          title: 'Security Consulting',
          description: 'Security Consulting to address IT Security requirements across Network  consulting services.',
          link: '/security-consulting',
        },
        {
          imgSrc: ServiceImg2,
          title: 'Audit & Compliance',
          description: 'VAPT Services, Security audit and guidance in implementing regulatory compilance solutions.',
          link: '/audit-&-compliance',
        },
        {
          imgSrc: ServiceImg4,
          title: 'Cloud Security',
          description: 'Manage, optimize and enhance cloud efficiency, storage & databases access to software',
          link: '/cloud-security',
        },
        {
          imgSrc: ServiceImg5,
          title: 'Design & Implementation',
          description: 'Solution Design and Implementation Services, Testing and Commissions automated work.',
          link: '/design-&-implementation',
        },
        {
          imgSrc: ServiceImg6,
          title: 'Managed IT Services',
          description: 'Managed IT solutions are designed to be there around the clock to ensure companies market.',
          link: '/managed-it-services',
        },
      ];
     return (
        <React.Fragment>
            {/*Services Page Start*/}
            <section className="team-details">
                <div className="container">
                    <div className="team-details__top">
                        <div className="team-details__img">
                            <img src={teamDetailsImg} alt="" />
                        </div>
                        <div className="team-details__content">
                            <div className="team-details__name-and-social-box">
                                <div className="team-details__name-box">
                                    <div className="team-details__name-box-shape">
                                        <img src={teamDtetailsShape} alt="" />
                                    </div>
                                    <h3 className="team-details__name">Join us</h3>
                                </div>
                             
                            </div>
                            <p className="team-details__top-text">
                            Join us for a journey of growth and discovery! Become part of our vibrant community where creativity thrives, ideas flourish, and opportunities abound. Together, we can achieve greatness and make a lasting impact. Don’t miss out—join us today and be part of something extraordinary.
                            </p>
                            <div className="team-details__btn-contact-inner">
                                <div className="team-details__btn-contact">
                                    <div className="team-details__btn-box">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <TestimonialOne></TestimonialOne>
            <ServicesPage services={servicesData} />
            <section className='service-d'>
            <div className="container">
            <div className="col-xl-12 col-lg-12">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    {/* <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div> */}
                                </div>
                               
                             
                            </div>
                        </div>
                        </div>
            </section>
            <ContactThree />
            {/*Services Page End*/}
        </React.Fragment>
    );
};
 
export default ServicesMain;
